import { Component, Input, Output, OnInit, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@src/store';
import { vaultActions } from '@src/store/reducers/vaultReducer';
import { VaultConnectionService } from '@src/services/VaultConnectionService.service';
import { Utils } from '@src/utils/util';

@Component({
    selector: 'vault-item',
    template: require('./vault-item.component.html'),
    styles: [require('./vault-item.component.scss')]
})
export class VaultItemComponent implements OnInit {
    @Output() public onDelete = new EventEmitter();
    @Output() public onSave = new EventEmitter();
    @Output() public onTest = new EventEmitter<any>();
    @Output() public onCancel = new EventEmitter<any>();
    @ViewChild('settingsContainer') public settingsContainer: ElementRef;

    public hasItemEditable = true;
    public vaultTypeList = [];

    private unSubscribe: any;
    private _vault: any;
    private tempVault: any;
    public configuration: any = {};

    public component: any;
    @Output() public onEditLink = new EventEmitter();

    constructor(private store: Store,
                private componentService: VaultConnectionService,
                private utils: Utils) {
    }

    @Input()
    public set vault(value) {
        this.configuration = {};
        this.tempVault = this.utils.deepCopy(value);
        this._vault = value;
        this.hasItemEditable = !this.vault;
        this.setVaultType();
        if (value && value.Configuration) {
            this.configuration = value.Configuration;
            this.selectConfig();
        }
    }

    public get vault() {
        return this._vault;
    }

    public set selectedVault(value: any) {
        this.vault.VaultType = value.Name;
        this.vault.VaultTypeId = value.ID;
    }

    public get selectedVault() {
        return this.setVaultType();
    }

    public async ngOnInit() {
        this.unSubscribe = this.store.subscribe(() => {
            const vaults = this.store.getState().vaults;
            if (vaults && vaults.vault_types) {
                this.vaultTypeList = vaults.vault_types;
                this.setVaultType();
                if (this.vaultTypeList.length > 0) {
                    this.unSubscribe();
                }
            }
        });
        this.store.dispatch({ type: vaultActions.GET_VAULT_TYPES });
    }

    public async save() {
        if (this.vault.Configuration.AccessInCredentials) {
            delete this.vault.Configuration.AccessKey;
            delete this.vault.Configuration.SecretAccessKey;
        }
        const copyVault = this.utils.deepCopy(this.vault);

        if (this.vault.isNew) {
            delete copyVault.isNew;
            delete copyVault.ID;
            const vaultId: string = await this.store.dispatch({
                type: vaultActions.SET_VAULT_CONFIGURATION,
                payload: { vault_configuration: copyVault }
            });
            if (vaultId) {
                this.store.dispatch({ type: vaultActions.GET_VAULTS });
                delete this.vault.isNew;
                this.onSave.emit(vaultId);
            }
        } else {
            const saveID = this.vault.ID;
            this.unSubscribe = this.store.subscribe(() => {
                if (this.store.getState().user.vault) {
                    this.vault.ID = saveID;
                    this.unSubscribe();
                }
            });
            this.store.dispatch({
                type: vaultActions.UPDATE_VAULT_CONFIGURATION,
                payload: { update_vault: copyVault }
            });
        }
    }

    public cancel() {
        const vault = Object.assign({}, this.tempVault);
        this.vault = vault;
        this.onCancel.emit(vault);
    }

    public setVaultType(): string {
        if (this.vaultTypeList && this.vault) {
            const vaultTypeId = this.vault.VaultTypeId;
            const type = this.vaultTypeList.find((type) => {
                return type.ID === vaultTypeId;
            });
            if (type) {
                this.vault.VaultType = type.Name;
                this.vault.VaultTypeId = type.ID;
                return type;
            }
        }
    }

    private selectConfig() {
        this.component = null;
        this.store.dispatch({
            type: vaultActions.GET_VAULT_CONFIGURATION,
            payload: { vaultTypeId: this.vault.VaultTypeId }
        }).then((res) => {
            this.createPage(res);
        });
    }

    public createPage(htmlTemplate) {
        this.component = this.componentService.createComponent(htmlTemplate);
    }

    public setData = (instance: any) => {
        if (this.configuration.AccessInCredentials === undefined) {
            this.configuration.AccessInCredentials = false;
        }
        instance.isDisabled = true;
        instance.isHidden = true;
        instance.data = this.configuration;
        instance.onEditLink = this.onEditLink;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/vault-management/vault-item/vault-item.component.ts